import FanDuel from "./FanDuel.png";
import DraftKings from "./DraftKings.png";
import BetRivers from "./BetRivers.png";
import MGM from "./MGM.png";
export default {
    FanDuel,
    DraftKings,
    BetRivers,
    MGM
}